/**
 * This file contains code responsible for position proper number of "boxes" in a row.
 *
 * How it works:
 *
 * * Define max number of rows using attribute `data-sd-boxer-rows="2"`
 * * Render safe number of "boxes" inside container with attribute `data-sd-boxer-rows`.
 *   What mean "safe number"? Let's assume your "box" has 200px of width, and max browser
 *   width may be 1980px. So in one row may be maximum 9 boxes. If you want to have 2 rows
 *   with 9 boxes in each, the "safe number" is 18.
 * * If user resizes browser window, number of boxes will be automatically changed to fit
 *   window size.
 *
 *  How to use it:
 *
 *      <div data-sd-boxes-rows="2">
 *          <div class="my-box">John</div>
 *          <div class="my-box">Kate</div>
 *          <div class="my-box">Sam</div>
 *          <div class="my-box">Mathew</div>
 *          <div class="my-box">Ola</div>
 *          <div class="my-box">Chris</div>
 *      </div>
 *
 * What `sd` prefix in attribute names stands for?
 * `sd` means `solodev`.
 *
 */

import Debounce from './utils/debounce'

export default class Boxer {

  constructor() {
    this.boxers = document.querySelectorAll('[data-sd-boxer-rows]');

    if (this.boxers.length) {
      this.init(this.boxers);
    }
  }

  init(boxers) {
    let len = boxers.length;

    while (len--) {
      this.boxer(boxers[len]);
    }
  };


  boxer(el) {
    const me = this;
    me.update(el);

    const debounce = new Debounce(() => {
      me.update(el);
    }, 500);

    // Update layout if browser window is resized.
    const debouncedUpdate = debounce.call();
    window.addEventListener('resize', debouncedUpdate);
  }

  update(el) {
    const items = el.children;

    if ( !items.length ) {
        return;
    }

    const
        cntEl = el,
        cntWidth = cntEl.clientWidth,
        item = items[0],
        style = item.currentStyle || window.getComputedStyle(item),
        itemWidth = item.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight),
        rowsNumber = parseInt(el.getAttribute('data-sd-boxer-rows')),
        perRow = Math.floor(cntWidth / itemWidth),
        max = (rowsNumber * perRow) - 1;

    let len = items.length - 1; // -1 to skip last element which is "add" button.

    if ( items.length > max ) {
      while (len--) {
          items[len].style.display = len >= max ? 'none' : '';
      }
    }
  }
}
